/**
 * Privy provider configuration.
 *
 * Privy is used purely for embedded-wallet ownership + intent signing —
 * not for session/auth (that's Supabase). Onboarding (Phase 2 step 4)
 * creates the embedded wallet on first login; useSignIntent() uses it.
 *
 * The provider is mounted only when VITE_PRIVY_APP_ID is set; otherwise
 * the wrapper in main.tsx renders children without Privy. useSignIntent()
 * checks PRIVY_CONFIGURED and throws a clear error if false.
 */

export const PRIVY_APP_ID = import.meta.env.VITE_PRIVY_APP_ID ?? '';
export const PRIVY_CONFIGURED = Boolean(PRIVY_APP_ID);

if (!PRIVY_CONFIGURED && import.meta.env.DEV) {
  console.warn(
    '[privy] VITE_PRIVY_APP_ID not set — embedded wallet + intent signing disabled. See .env.example.',
  );
}

/**
 * Privy SDK config. We use email-only login so the Privy login email
 * matches the Supabase auth email (one user identity across both systems).
 * `createOnLogin: 'all-users'` guarantees every login produces an
 * embedded wallet ready to sign intents.
 */
export const privyConfig = {
  loginMethods: ['email'] as ['email'],
  appearance: {
    theme: 'light' as const,
    accentColor: '#1E3A36' as `#${string}`, // patina — chainMuse primary accent
    logo: '/brand/art_Logo.png',
  },
  embeddedWallets: {
    createOnLogin: 'all-users' as const,
    requireUserPasswordOnCreate: false,
    noPromptOnSignature: false,
  },
};
